<template>
	<div class="wrapper">
		<sub-ibox-title :is-show-back=true>
			<!--<p slot="title">{{params.id ? '编辑门店':'新增门店'}}</p>-->
			<p slot="title">添加结算信息</p>
		</sub-ibox-title>
		<section class="content">
			<div class="detail-cont">
				<div class="fx fx-y-center">
					<div class="title fx w120 m-r-5">商户名称</div>
					<div class="fx-fill">商户名称商户名称</div>
				</div>
				<z-input type="text" title="结算银行卡号" class="m-t-15" isMust=true placeholder="请输入结算账号"></z-input>
				<z-input type="text" title="户名" class="m-t-15" isMust=true placeholder="请输入开户名称"></z-input>
				<z-input type="text" title="开户行" class="m-t-15" isMust=true placeholder="请输入开户银行名称"></z-input>
				<z-input type="text" title="开户行所在地" class="m-t-15" isMust=true placeholder="请输入开户行地址"></z-input>
				<!--<z-input type="text" title="结算周期" class="m-t-15" isMust=true placeholder="T+1"></z-input>-->
				<div class="fx  m-t-15">
					<div class="title fx w120 m-r-5"><p class="ask-cont"><i class="ask" v-if="isMust">*</i></p><span class="fx-fill">结算周期</span></div>
					<div class="fx-fill m-l-5">
						T+<input type="number" class="number-style" name="" id="" value="1" />
					</div>
				</div>
				<div class="fx fx-y-center m-t-15">
					<div class="title fx w120 m-r-5"><p class="ask-cont"><i class="ask">*</i></p><span class="fx-fill">分润规则</span></div>
					<div class="fx-fill fx fx-y-center">每笔交易平台分润 <div class="w100"><input type="text" name="" id="" value="" class="input b-r-5" /></div>%</div>
				</div>
				<div class="fx  m-t-15">
					<div class="title fx w120 m-r-5">订单退款时分润返还设置</div>
					<div class="fx-fill m-l-5">
						<label class="fx fx-y-center">
							<input type="radio" name="switch" id="" value="" class="radio m-r-5 b-r-50"/>
							<div>不退分润<span class="c-g">（对订单进行任何退款操作，均不返还分润给收款方）</span></div>
						</label>
						<label class="fx fx-y-center m-t-10">
							<input type="radio" name="switch" id="" value="" class="radio m-r-5 b-r-50"/>
							<div>全额退还分润<span class="c-g">（对订单进行任何退款操作，返还全部分润给收款方）</span></div>
						</label>
					</div>
				</div>
			</div>
			<div class="m-t-20 fx">
				<p class="w120 m-r-5 fx-shrink"></p>
				<a class="z-btn z-btn-primary b-r-3" @click="handleAddBtn">保存</a>
			</div>
		</section>
	</div>
</template>
<script>
	import {
		mapActions,
		mapState
	} from 'vuex'

	export default {
		name: 'ShopEdit',
		components: {},
		data() {
			return {
				params: {
					id: null, //店铺ID
					name: null, // 导航标题
					tel: null, //店铺名称
					logo_url: null, // 店铺位置
					latitude: null, //纬度
					longitude: null, //经度,
					address: null//地址
				},
				picList: []
			}
		},
		mounted() {
			const id = this.$route.query.shopId
			if(this.$re_Number(id)) this.handleGetShopInfo(id)
		},
		/*
		 * 属性计算
		 */
		computed: {},
		/*
		 * 事件处理
		 */
		methods: {
			handleUploadSuccess(url){
				this.params.logo_url = url;
			},
			//保存
			async handleAddBtn() {
				return this.$warning('该能力暂未开通,请联系运营人员');
//				if(!this.params.logo_url) return this.$warning('请上传封面( ･´ω`･ )');
//				if(!this.params.name) return this.$warning('请填写门店名称( ･´ω`･ )');
//				if(!this.$re_phone(this.params.tel)) return this.$warning('联系方式输入不正确 ( ･´ω`･ )');
//				if(!this.$re_longitude(this.params.longitude)) return this.$warning('请输入正确经度( ･´ω`･ )');
//				if(!this.$re_latitude(this.params.latitude)) return this.$warning('请输入正确纬度( ･´ω`･ )');
//				if(!this.params.address) return this.$warning('请填写门店地址( ･´ω`･ )');
//				try{
//					await this.saveShopInfo(this.params);
//					this.$success('操作成功');
//					this.$back();
//				}catch(e){
//					this.$warning(e);
//				}
			},
			
			//获取门店信息
			async handleGetShopInfo(id) {
				try{
					this.params = await this.getShopInfo({id})
				}catch(e){
					this.$errorMsg(e)
				}
			},
			...mapActions(['getShopInfo', 'saveShopInfo']),
		}
	}
</script>
<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
	
	.c-g {
		color: $color-font-sub;
	}
	.content {
		border-top: none;
	}
	.w100{
		width: px-em(200px);
		margin: 0 5px;
	}
	.detail-cont {
		width: 600px;
	}
	.number-style{
		border: 1px solid $color-border;
		width: 100px;
		padding: px-em(16px) px-em(20px);
		border-radius: 5px;
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.detail-cont{
			width: 100%;
		}
		.shop-tips{
			display: block;
		}
	}
</style>


// WEBPACK FOOTER //
// ClearInfo.vue?626429b2